import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=3872bbb5"
import script from "./stepper.vue?vue&type=script&lang=js"
export * from "./stepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports